export default "__VITE_ASSET__Dsp_IklN__"